import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const BRAND_LOGO =
  "https://customer-assets.emergentagent.com/job_partflow-africa/artifacts/2oqemmeo_logo.webp";

export const HERO_IMG =
  "https://images.unsplash.com/photo-1728474751252-9c085659f6ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxtZWNoYW5pYyUyMGZpeGluZyUyMGNhciUyMGdhcmFnZXxlbnwwfHx8fDE3NzY0NzgwNjV8MA&ixlib=rb-4.1.0&q=85";

export const CITY_IMG =
  "https://images.unsplash.com/photo-1766087124181-0677409b73eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxBZnJpY2FuJTIwY2l0eSUyMHJvYWQlMjB0cmFmZmljfGVufDB8fHx8MTc3NjQ3ODA2NXww&ixlib=rb-4.1.0&q=85";

export const LOGISTICS_IMG =
  "https://images.unsplash.com/photo-1634638022229-5a52221886dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxjYXJnbyUyMHNoaXAlMjBjb250YWluZXJzJTIwcG9ydHxlbnwwfHx8fDE3NzY0NzgwNTN8MA&ixlib=rb-4.1.0&q=85";

export function formatMoney(n, currency = "USD") {
  if (n == null) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(n);
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
